import { Component, Input, OnInit } from '@angular/core';
import { Ng2DeviceService } from 'ng2-device-detector';

import { RestaurantService } from './restaurant.service';

import { Restaurant } from './restaurant';

import 'rxjs/add/operator/switchMap';

@Component({
	selector: 'top-gallery',
	templateUrl: './top-gallery.component.html',
	styleUrls: ['./top-gallery.component.css']/*,
	animations: [
	    trigger('top-gallery-item', [
	            state('inactive', style({
	                alpha: '0'
	            })),
	            state('active', style({
	                alpha: '1'
	            })),
	            transition('inactive => active', animate('200ms ease-in')),
	            transition('active => inactive', animate('200ms ease-out'))
	        ]
	    )
	]
	*/
})

export class TopGalleryComponent implements OnInit {
    deviceInfo = null;
    device = "unknown";
	constructor(
		private m_restaurant_service: RestaurantService,
                private deviceService: Ng2DeviceService,
  	) {}
	m_restaurant: Restaurant;

	ngOnInit(): void {
		this.getRestaurant();
	}

	getRestaurant(): void {
		console.log("TopGalleryComponent getRestaurant")
		this.m_restaurant_service.getRestaurant(this.m_restaurant_service.name).then(
			restaurant => {
				console.log("TopGalleryComponent callback")
				console.log("TopGalleryComponent callback restaurant: " + restaurant)
				console.log("TopGalleryComponent callback restaurant: " + restaurant.title)
				console.log("TopGalleryComponent callback restaurant: " + restaurant.images)
				this.m_restaurant = restaurant;
                                   this.deviceInfo = this.deviceService.getDeviceInfo();
                                   this.device = this.deviceInfo.device;
                                 console.log("MOBILE INFO " ,this.deviceInfo.device);

			}
		);
	}
}


// WEBPACK FOOTER //
// /Users/kala/Sites/weeloy_website_engine/website-new-template-fun/src/app/top-gallery.component.ts